module.exports = __webpack_public_path__ + "img/app-parent.be542811.png";